import React, { useEffect, useState } from 'react';
import { AccessType } from '../../enums/AccessType';
import { useMutationWithAuth } from '../../hooks/useMutationWithAuth';
import { removeItem, setItem } from '../../helpers/storage';
import { IUser } from '../../interfaces/user/user';
import { IFileUploadRestrictionDto } from '../../interfaces/fileUpload/fileUploadRestrictionDto';
import Cookies from 'js-cookie';
import { initializeFeatureFlagsAfterLogin } from '../../helpers/featureFlags/featureFlagIntegrationNew';

export interface IApplicationProps { 
    paramsValue?: string | null; // Optional if you want to pass the parameter value
}

const AppSAML: React.FunctionComponent<IApplicationProps> = ({ paramsValue }) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [email, setEmail] = useState<string>('');
    const [{ }, bootstrapRequest] = useMutationWithAuth(() => ({
        url: `${Env.API_URL}/bootstrap/fileUploadRestrictions`,
        options: {
            method: 'GET',
        },
    }));
    const rememberAuth = (user: IUser, token: string) => {
        removeItem('user');
        setItem('user', JSON.stringify({
            user,
            token,
        }));
    };

    const rememberFileUploadRestrictions = (restrictions: IFileUploadRestrictionDto) => {
        removeItem('fileUploadRestrictions');
        setItem('fileUploadRestrictions', JSON.stringify(restrictions));
    };
    useEffect(() => {
        const getUserCookie = async () => {
            const token = await Cookies.get('accessToken');
            const response = await fetch(`${Env.API_URL}/auth/me`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'lang': 'en',
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.status === 401) {
                window.location.href = '/logout';
                setItem('logout', 'yes');
                return;
            } else if (response.status === 200) {
                setItem('logout', 'no');
            }
            const result = await response.json();

            rememberAuth(result.user, result.accessToken);

            rememberFileUploadRestrictions((await bootstrapRequest()).body);
            setItem('LoginUserData', JSON.stringify(result));
            
            // Initialize feature flags after successful login
            try {
               
                await initializeFeatureFlagsAfterLogin();
            } catch (error) {
                // tslint:disable-next-line:no-console
                console.error('Failed to initialize feature flags after login:', error);
            }
            const accessType = result.user.accessType;
            let redirectPath = '';

            if (accessType === AccessType.LQAAdmin || accessType === AccessType.LQABasic) {
            // Admin users always go to the admin section.
            redirectPath = '/admin';
            } else if ([AccessType.brandClientUser, AccessType.masterClientUser, AccessType.clientUser].includes(accessType)) {
            // For brand client users, use the provided params value if available; otherwise, use the brand dashboard.
            redirectPath = paramsValue || '/brand/dashboard';
            } else {
            // For any other access type, use the params value if provided; otherwise, redirect to the hotel dashboard.
            redirectPath = paramsValue || '/hotel/dashboard';
            }

            window.location.replace(`${Env.FRONTEND_URL}${redirectPath}`);

        };
        getUserCookie();
    }, [paramsValue]);

    if (loading) {
        return <p>loading ...</p>;
    }

    return (
        <p>Hello {email}!</p>
    );
};

export default AppSAML;
